/*
 * @Author: KellyYang
 * @Date: 2022-06-30 14:02:25
 * @LastEditors: KellyYang
 * @Description: 企业文化
 */
import React, { Fragment } from "react";
import CastList from "@/pages/Case/components/CastList";
import enterpriseDynamic from "@/assets/img/about-page/enterprise-dynamic.png";
import enterpriseDynamic1009 from "@/assets/img/about-page/enterprise-dynamic-20221009.png";
import enterpriseDynamic1013 from "@/assets/img/about-page/enterprise-dynamic-20221013.png";
import './index.less'

const caseList = [
  { img: enterpriseDynamic1013, title: '走访｜锦誉征信与海南银行澄迈科技支行开展业务交流活动', content: '为加强在“基建供应链金融业务”方面的交流与合作，推动业务落地，10月12日上午，锦誉征信服务（海南）有限公司市场团队在副总裁陶理伟的带领下走访了海南银行澄迈科技支行，开展业务交流活动，就基建供应链业务的发展方向和进一步深化合作进行交流与探讨。', typeBg: '#FF9442', time: '2022.10.13' },
  { img: enterpriseDynamic1009, title: '信用管家线下专题培训会圆满召开', content: '近日，为进一步提高团队和合作伙伴的征信业务服务能力，锦誉征信服务（海南）有限公司组织开展以信用管家为主题的线下专题培训会。', typeBg: '#FF9442', time: '2022.10.09' },
  { img: enterpriseDynamic, title: '建筑工程纾困和融资座谈会', content: '伴随着房地产调控政策的施行，建筑行业的业务量明显下滑，应收账款回款难，回款慢等问题愈发严重，整个行业发展面临极大挑战。与此同时，在国家大力推动新基建的战略部署背景下，行业发展又存在很好的发展机遇。为应对建筑行业困境，帮助建筑行业小微企业解决当前经营资金难点，推动行业发展，2022年6月16日，海南省湖北商会联合海南省现代管理研究会、锦誉征信服务(海南)有限公司，海口召开第一期座谈会。', typeBg: '#FF9442', time: '2022.06.23' },
]
const EnterpriseDynamic = () => {
  return (
    <Fragment>
      <div>
        <CastList caseList={caseList}></CastList>
      </div>
    </Fragment>
  )
}
export default EnterpriseDynamic;
